import { Button, Loader, PasscodeInput } from '@ax/ui';
import style from './Login.module.scss';
import { usePasscodeSession } from '@/hooks/usePasscodeSession.tsx';
import { useState } from 'react';
import { routerPaths } from '@ax/constants';
import { Link } from 'react-router-dom';

export interface CreatePasscodeFormProps {
  onPasscodeInput?: (username: string, passcode: string) => void;
  onPasscodeChange?: (value: string) => void;
  onChangeUsername?: () => void;
  isLoading?: boolean;
  hasError?: boolean;
  errorMessage?: string;
}

export function PasscodeChallengeForm({
  isLoading = false,
  onPasscodeInput,
  onPasscodeChange,
  hasError = false,
  onChangeUsername,
  errorMessage,
}: CreatePasscodeFormProps) {
  const { session: { name, email } = {}, isSessionInitialized } = usePasscodeSession();
  const [isUserConfirmed, setIsUserConfirmed] = useState(false);

  return (
    <div className={style.login__form__body}>
      <div className={style.login__form__body__subtitle}>Welcome back,</div>
      <div className={style.login__form__body__pin_form__username}>
        <h1>{name || email}</h1>
      </div>
      <div className={style.login__form__body__pin_form__signout}>
        <Link
          to={'#'}
          onClick={() => onChangeUsername && onChangeUsername()}
        >
          (Not you? Tap here to change.)
        </Link>
      </div>
      <div className={style.login__form__body__pin_form}>
        {hasError && (
          <div className={style.login__form__body__pin_form__error}>
            {errorMessage ? (isUserConfirmed ? errorMessage : '') : 'Incorrect PIN'}
          </div>
        )}
        {!isLoading && isUserConfirmed && isSessionInitialized && (
          <PasscodeInput
            onCompleted={(passcode) => onPasscodeInput && onPasscodeInput(email!, passcode)}
            onChange={onPasscodeChange}
          />
        )}
        {!isLoading && !isUserConfirmed && isSessionInitialized && (
          <div className={style.login__form__body__pin_form__button}>
            <Button
              variant={'primary'}
              onClick={() => setIsUserConfirmed(true)}
            >
              Continue
            </Button>
          </div>
        )}
        {isLoading && (
          <div className={style.login__form__body__pin_form__loading}>
            <Loader color="#344bc6" />
          </div>
        )}
        <div className={style.login__form__footer}>
          <Link
            to={routerPaths.support}
            className={style.login__form__footer__link}
          >
            Having difficulties?
          </Link>
        </div>
      </div>
    </div>
  );
}
